const STORAGE_KEY = 'heimatwelt:wishlist:v1';

function readWishlist() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    const parsed = value ? JSON.parse(value) : [];

    return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
  } catch (_error) {
    return [];
  }
}

function writeWishlist(items) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function getProductFromButton(button) {
  return {
    id: button.dataset.wishlistId || '',
    handle: button.dataset.wishlistHandle || '',
    title: button.dataset.wishlistTitle || '',
    url: button.dataset.wishlistUrl || '#',
    image: button.dataset.wishlistImage || '',
    price: button.dataset.wishlistPrice || '',
  };
}

function setToggleState(button, isActive) {
  button.classList.toggle('is-active', isActive);
  button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  button.setAttribute('aria-label', isActive ? 'Von Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
}

function syncToggles(items = readWishlist()) {
  const handles = new Set(items.map((item) => item.handle));

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    setToggleState(button, handles.has(button.dataset.wishlistHandle));
  });
}

function syncCounts(items = readWishlist()) {
  document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
    counter.textContent = String(items.length);
    counter.hidden = items.length === 0;
  });
}

function getCurrentMobileCartCount() {
  const counter = document.querySelector('[data-mobile-cart-count]');
  const currentValue = parseInt(counter?.textContent ?? '0', 10);

  if (Number.isFinite(currentValue)) return currentValue;

  try {
    const cached = JSON.parse(sessionStorage.getItem('cart-count') || '{}');
    const cachedValue = parseInt(cached.value || '0', 10);

    return Number.isFinite(cachedValue) ? cachedValue : 0;
  } catch (_error) {
    return 0;
  }
}

function setMobileCartCount(count) {
  document.querySelectorAll('[data-mobile-cart-count]').forEach((counter) => {
    counter.textContent = String(count);
    counter.hidden = count === 0;
  });
}

function renderWishlist(items = readWishlist()) {
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const list = document.querySelector('[data-wishlist-items]');

  if (!drawer || !list) return;

  drawer.classList.toggle('is-empty', items.length === 0);
  list.replaceChildren();

  items.forEach((item) => {
    const row = document.createElement('div');
    row.className = 'wishlist-drawer__item';

    const link = document.createElement('a');
    link.href = item.url || '#';
    link.className = 'wishlist-drawer__image-link';
    link.setAttribute('aria-label', item.title || 'Produkt öffnen');

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'wishlist-drawer__image';
      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';
      link.append(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'wishlist-drawer__image';
      link.append(placeholder);
    }

    const textLink = document.createElement('a');
    textLink.href = item.url || '#';
    textLink.className = 'wishlist-drawer__text';

    const title = document.createElement('p');
    title.className = 'wishlist-drawer__item-title';
    title.textContent = item.title || 'Produkt';

    const price = document.createElement('p');
    price.className = 'wishlist-drawer__price';
    price.textContent = item.price || '';

    textLink.append(title, price);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wishlist-drawer__remove';
    remove.dataset.wishlistRemove = item.handle;
    remove.setAttribute('aria-label', `${item.title || 'Produkt'} entfernen`);
    remove.innerHTML =
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.47 4.47a.75.75 0 0 1 1.06 0L10 8.94l4.47-4.47a.75.75 0 1 1 1.06 1.06L11.06 10l4.47 4.47a.75.75 0 1 1-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>';

    row.append(link, textLink, remove);
    list.append(row);
  });
}

function syncWishlist() {
  const items = readWishlist();

  syncToggles(items);
  syncCounts(items);
  renderWishlist(items);
}

function toggleProduct(button) {
  const product = getProductFromButton(button);
  if (!product.handle) return;

  const items = readWishlist();
  const existingIndex = items.findIndex((item) => item.handle === product.handle);

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else {
    items.unshift(product);
  }

  writeWishlist(items);
  syncWishlist();
}

function removeProduct(handle) {
  const items = readWishlist().filter((item) => item.handle !== handle);

  writeWishlist(items);
  syncWishlist();
}

function openWishlistDrawer() {
  const drawer = document.querySelector('[data-wishlist-drawer]');

  if (!drawer) return;

  renderWishlist();

  if (typeof drawer.showModal === 'function') {
    drawer.showModal();
  } else {
    drawer.setAttribute('open', '');
  }
}

function closeWishlistDrawer() {
  const drawer = document.querySelector('[data-wishlist-drawer]');

  if (!drawer) return;

  if (typeof drawer.close === 'function') {
    drawer.close();
  } else {
    drawer.removeAttribute('open');
  }
}

function openCartDrawer(event, link) {
  const cartDrawerTrigger = document.querySelector('.cart-drawer [data-testid="cart-drawer-trigger"]');

  if (!cartDrawerTrigger) return;

  event.preventDefault();
  cartDrawerTrigger.click();
  link.blur();
}

function openSearchModal(event) {
  const searchButton = document.querySelector('.search-modal__button');

  if (!searchButton) return;

  event.preventDefault();
  searchButton.click();
}

function handleMobileCartUpdate(event) {
  const itemCount = event.detail?.data?.itemCount ?? 0;
  const comingFromProductForm = event.detail?.data?.source === 'product-form-component';
  const nextCount = comingFromProductForm ? getCurrentMobileCartCount() + itemCount : itemCount;

  setMobileCartCount(nextCount);
}

document.addEventListener('click', (event) => {
  const wishlistToggle = event.target.closest('[data-wishlist-toggle]');
  if (wishlistToggle) {
    event.preventDefault();
    event.stopPropagation();
    toggleProduct(wishlistToggle);
    return;
  }

  const wishlistOpen = event.target.closest('[data-wishlist-open]');
  if (wishlistOpen) {
    event.preventDefault();
    openWishlistDrawer();
    return;
  }

  const wishlistClose = event.target.closest('[data-wishlist-close]');
  if (wishlistClose) {
    closeWishlistDrawer();
    return;
  }

  const wishlistRemove = event.target.closest('[data-wishlist-remove]');
  if (wishlistRemove) {
    event.preventDefault();
    removeProduct(wishlistRemove.dataset.wishlistRemove);
    return;
  }

  const cartLink = event.target.closest('[data-mobile-nav-cart]');
  if (cartLink) {
    openCartDrawer(event, cartLink);
    return;
  }

  const searchButton = event.target.closest('[data-mobile-nav-search]');
  if (searchButton) {
    openSearchModal(event);
  }
});

document.addEventListener('DOMContentLoaded', syncWishlist);
document.addEventListener('shopify:section:load', syncWishlist);
document.addEventListener('cart:update', handleMobileCartUpdate);
window.addEventListener('storage', syncWishlist);
syncWishlist();
